import React from "react";
import EmailSignature1 from "@/components/utils/signatures/email-v1";
import EmailSignature2 from "@/components/utils/signatures/email-v2";
import EmailSignature3 from "@/components/utils/signatures/email-v3";

import { Icon } from "components";
import { LINK } from "icons";

const EmailSignatures = () => {
  const signatures = [
    {
      id: "email-signature-temp1",
      name: "Email Signature 1",
      component: EmailSignature1,
    },
    {
      id: "email-signature-temp2",
      name: "Email Signature 2",
      component: EmailSignature2,
    },
    {
      id: "email-signature-temp3",
      name: "Email Signature 3",
      component: EmailSignature3,
    },
  ];

  return (
    <div className="space-y-8 p-6 flex-1">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Email Signatures</h1>
          <p className="text-gray-600 mt-1">
            Choose and copy your preferred email signature template
          </p>
        </div>
        <div>
          <a
            href="https://sites.google.com/7span.com/knowledgebase/tools/gmail"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors"
          >
            How to use?
            <Icon icon={LINK} className="size-4" />
          </a>
        </div>
      </div>
      <div className="flex gap-8 flex-wrap items-start">
        {signatures.map((signature) => {
          const Component = signature.component;
          return <Component id={signature.id} key={signature.id} />;
        })}
      </div>
    </div>
  );
};

export default EmailSignatures;
